import { useParams } from "react-router-dom";
import BackButton from "src/components/BackButton";
import useWindowSize from "src/hooks/useWindowSize";
import RegistrationsSidebar from "src/components/tasks/panes/registration/RegistrationsSidebar";
import SelectedRegistrationPane from "src/components/tasks/panes/registration/SelectedRegistrationPane";
import { useTranslation } from "react-i18next";

const SelectRegistrationPane = () => {
	const { t } = useTranslation("registrations", {
		keyPrefix: "select-registration-pane",
	});
	const { id, registration } = useParams() as any;
	const { isTablet } = useWindowSize();

	return (
		<div className="flex gap-4 md:flex-row flex-col flex-1 min-h-[80vh] h-full">
			<RegistrationsSidebar />
			{registration && (
				<div className="flex flex-1 flex-col h-full">
					{isTablet && (
						<BackButton
							to={`/tasks/${id}/show`}
							label={t("back")}
							className="mb-4"
						/>
					)}
					<SelectedRegistrationPane id={registration} />
				</div>
			)}
			{!registration && !isTablet && (
				<div className="flex-1 flex flex-col h-full justify-center items-center">
					<strong>{t("empty.title")}</strong>
				</div>
			)}
		</div>
	);
};

export default SelectRegistrationPane;
